type ApplyOverlayTextStylesProps = {
  overlayTextarea: HTMLTextAreaElement;
  fabricTextbox: fabric.Textbox;
  canvasZoom: number;
  isPhotoTextZone?: boolean;
};

export const applyOverlayTextStyles = ({
  overlayTextarea,
  fabricTextbox,
  canvasZoom,
  isPhotoTextZone,
}: ApplyOverlayTextStylesProps) => {
  if (!overlayTextarea || !fabricTextbox) {
    throw new Error('Overlay textarea or fabric textbox is not defined');
  }

  const scale = fabricTextbox.scaleY || 1;

  // Set styles with fallbacks
  const textboxColor = fabricTextbox?.fill || 'black';
  const fontSize = fabricTextbox?.fontSize || 16;
  const padding = fabricTextbox?.padding || 5;
  const textAlign = fabricTextbox?.textAlign || 'left';
  const fontWeight = fabricTextbox.fontWeight || 'normal';
  const fontFamily = fabricTextbox.fontFamily || 'Arial';
  const angle = fabricTextbox.angle || 0;

  const zoomedPadding = padding * canvasZoom;
  const zoomedAngle = angle * canvasZoom * scale;

  // Line height needs to be converted to px to scale properly
  const lineHeight = fabricTextbox.getHeightOfLine(0);
  const zoomedLineHeight = lineHeight * canvasZoom * scale;
  const zoomedFontSize = fontSize * canvasZoom * scale;

  const overlayBorderWidth = 2;

  overlayTextarea.style.color = textboxColor.toString();
  overlayTextarea.style.fontWeight = fontWeight.toString();
  overlayTextarea.style.fontFamily = fontFamily;
  overlayTextarea.style.textAlign = textAlign;

  overlayTextarea.style.fontSize = `${zoomedFontSize.toString()}px`;
  overlayTextarea.style.lineHeight = `${zoomedLineHeight.toString()}px`;
  overlayTextarea.style.transformOrigin = `${fabricTextbox.originX} ${fabricTextbox.originY}`;
  if (isPhotoTextZone) {
    return { overlayTextarea };
  }
  overlayTextarea.style.padding = `${zoomedPadding}px`;
  overlayTextarea.style.transform = `rotate(${zoomedAngle}deg) translate(${0}px, ${-(overlayBorderWidth / 2)}px)`;
  return { overlayTextarea };
};
